'use client';

import { ResponsiveStyleProp } from '@coolblue-development/freddy';
import goToShoppingCartTrigger from '@coolblue-development/ga4-events/triggers/AddToCartPage/goToShoppingCartTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { AddToCartPageType } from '@features/add-to-cart-page/typings/AddToCartPageSection';
import { useTranslation } from '@i18n/useTranslation';

import SharedShoppingCardButton from '../SharedShoppingCartButton';

type Props = {
  productId: number;
  href: string;
  pageType: AddToCartPageType;
  flex?: ResponsiveStyleProp<'flex'>;
};

export default function ShoppingCartButton({ productId, href, pageType, flex }: Props) {
  const { t } = useTranslation('webshop');
  const { trackEvent } = useAnalytics();

  function onClick() {
    trackEvent(
      goToShoppingCartTrigger({
        sub_feature: pageType,
        primary_item_id: productId
      })
    );
  }

  return (
    <SharedShoppingCardButton
      flex={flex}
      variant='action'
      onClick={onClick}
      component='a'
      href={href}
      fullWidth
    >
      {t('addToCart.viewShoppingCart')}
    </SharedShoppingCardButton>
  );
}
